import K2Cloud from 'assets/illustrations/partners/k2Cloud.svg';
import YandexCloud from 'assets/illustrations/partners/yandexCloud.svg';
// import ArenaData from 'assets/illustrations/partners/arenaData.svg';
import CloudRu from 'assets/illustrations/partners/cloud.ru.svg';
import Postgres from 'assets/illustrations/partners/postgres.svg';
import Naumen from 'assets/illustrations/partners/naumen.svg';
import Nubes from 'assets/illustrations/partners/nubes.svg';
import VkCloud from 'assets/illustrations/partners/vkCloud.svg';
import Oxygen from 'assets/illustrations/partners/oxygen.svg';
import AstraLinux from 'assets/illustrations/partners/astraLinux.svg';
import Selectel from 'assets/illustrations/partners/selectel.svg';
// import BeelineCloud from 'assets/illustrations/partners/beelineCloud.svg';
import Sber from 'assets/illustrations/partners/sber.svg';
import Yandex360 from 'assets/illustrations/partners/yandex360.svg';
import MWS from 'assets/illustrations/partners/mws.svg';

export const aboutUsPartnersPropsData = {
  title: 'Наши партнёры',
  description:
    'ASTON сотрудничает с ведущими технологическими компаниями, чтобы создавать надёжные и масштабируемые решения',
  cardsData: [
    { src: K2Cloud, alt: 'K2 Cloud' },
    // { src: ArenaData, alt: 'Arena Data' },
    { src: Postgres, alt: 'Postgres Pro' },
    { src: Nubes, alt: 'nubes' },
    { src: Oxygen, alt: 'Oxygen' },
    { src: Selectel, alt: 'Selectel' },
    { src: Sber, alt: 'Сбер' },
    { src: MWS, alt: 'MWS' },
    { src: YandexCloud, alt: 'Yandex Cloud' },
    { src: CloudRu, alt: 'cloud.ru' },
    { src: Naumen, alt: 'Naumen' },
    { src: VkCloud, alt: 'VK Cloud' },
    { src: AstraLinux, alt: 'Astra Linux' },
    // { src: BeelineCloud, alt: 'beeline cloud' },
    { src: Yandex360, alt: 'Яндекс 360' },
  ],
};
